import { useState } from "react";
import { useJoinWaitlist, useWaitlistCount } from "../../../lib/api/waitlist.api";
import { useScrollReveal } from "../hooks/useScrollReveal";
import { track } from "../../../lib/analytics";

type WaitlistState = "idle" | "submitting" | "success" | "already" | "error";

export function WaitlistSection() {
  const [email, setEmail] = useState("");
  const [state, setState] = useState<WaitlistState>("idle");
  const joinWaitlist = useJoinWaitlist();
  const { data: countData } = useWaitlistCount();
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.15, "waitlist");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setState("submitting");
    joinWaitlist.mutate(
      { email: email.trim() },
      {
        onSuccess: (data) => {
          if (data.status === "success") {
            setState("success");
            track("waitlist_submitted", {});
          } else {
            setState("already");
          }
          setEmail("");
        },
        onError: () => setState("error"),
      },
    );
  };

  return (
    <section className="py-16 px-6">
      <div
        ref={ref}
        className={`max-w-md mx-auto transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <h2 className="text-2xl font-bold text-ink">
          {countData && countData.count > 0
            ? <>Rejoignez les <span className="text-accent">{countData.count}</span> inscrits sur la waitlist.</>
            : <>Soyez le <span className="text-accent">1er</span> sur la waitlist.</>}
        </h2>
        <p className="mt-2 text-ink-muted text-sm leading-relaxed">
          Palnia est en bêta ouverte — vous pouvez l'utiliser dès maintenant.
          En rejoignant la waitlist, vous serez prévenu en priorité
          des nouvelles fonctionnalités et de la sortie officielle. Un mail
          de temps en temps, jamais de spam.
        </p>

        {state === "success" || state === "already" ? (
          <div
            className={`mt-6 p-4 rounded-xl border text-sm font-medium ${
              state === "already"
                ? "border-accent/30 bg-accent/10 text-accent"
                : "border-success/30 bg-success/10 text-success"
            }`}
          >
            {state === "already"
              ? "Vous êtes déjà inscrit. On vous tient au courant !"
              : "C'est noté. On vous écrit dès que c'est prêt."}
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 flex gap-2">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="votre@email.com"
              required
              className="flex-1 px-4 py-3 bg-surface-alt border border-border
                text-ink placeholder:text-ink-faint focus:outline-none
                focus:ring-2 focus:ring-accent/30 focus:border-accent/40
                rounded-xl text-sm"
            />
            <button
              type="submit"
              disabled={state === "submitting"}
              className="px-5 py-3 text-sm font-semibold text-white bg-accent
                hover:bg-accent-hover disabled:opacity-50 rounded-xl
                transition-colors whitespace-nowrap"
            >
              {state === "submitting" ? "..." : "OK"}
            </button>
          </form>
        )}

        {state === "error" && (
          <p className="mt-2 text-xs text-danger">
            Quelque chose a planté. Réessayez.
          </p>
        )}
      </div>
    </section>
  );
}
